import { FC } from "react";
import { Flex, Text, tokens } from "shared/components/Spor";
import { useTheme } from "styled-components";

type SectionEmptyStateProps = {
  message: string;
};

export const SectionEmptyState: FC<SectionEmptyStateProps> = ({ message }) => {
  const theme = useTheme();
  return (
    <Flex
      width="100%"
      justifyContent="flex-start"
      alignSelf="flex-start"
      pb={tokens.default.size.spacing[2]}
    >
      <Text variant="sm" color={theme.colorTextSecondary}>
        {message}
      </Text>
    </Flex>
  );
};
